<template>
  <div id="home">
    <div class="skg-pic"></div>
    <div class="skg-tag">
      <div class="name">SKG Construction</div>
      <div class="tag">Building Together Since 1996</div>
      <div class="scroll">scroll</div>
      <i class="fas fa-chevron-down fa-1x"></i>
    </div>
    <about />
    <services />
    <projects />
    <contact />
  </div>
</template>

<script>
import About from "@/components/aboutComponent";
import Services from "@/components/servicesComponent";
import Projects from "@/components/projectsComponent";
import Contact from "@/components/contactComponent";
import Foot from "@/components/footerComponent";

export default {
  name: "Home",
  components: {
    About,
    Services,
    Projects,
    Contact,
    Foot,
  },
};
</script>

<style>
.skg-pic {
  background-image: url("../assets/modern_house_picture_0175.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  background-position: center center;
}
.skg-tag {
  background: rgba(0, 0, 0, 0.5) !important;
  color: rgb(240, 233, 233);
  position: absolute;
  bottom: 5vh;
  letter-spacing: 0.25rem;
  width: 100%;
  max-width: 100%;
  z-index: 1;
  text-shadow: 0.1rem 0.1rem 0.4rem black;
  text-align: center;
}
.scroll {
  font-size: 12px !important;
}
.name {
  font-size: 6vw !important;
}
.tag {
  font-size: 3.5vw !important;
}
</style>
